/*
*  Engine que renderiza o formulário, adiciona todos os listeners, recupera seus valores e realiza suas validações.
* */

import RouteSurveyModal from 'react/containers/modals/RouteSurveyModal';
import * as routeSurveyModalActions from 'react/api/actions/routeSurveyModal';
import { createIncludesTestTo } from 'react/utils/utils';
import { CustomProvider, renderComponent } from 'react/utils/renderUtils';
import { actionCreators as actionsModals } from 'react/api/actions/modals';
import { PHOTO_ALBUM_MODAL_KEY } from 'react/containers/modals/PhotoAlbumModal/PhotoAlbumModal';


Monet.FormBuilder = function (formLayout, crudStage, divContainer, tabSelector, callbacks) {

    this.formLayout = formLayout;
    this.renderedHTML = "";
    this.crudStage = crudStage;
    this.page = null;
    this.layout = null;
    this.section = {};
    this.entity = this.formLayout.userInterfaceAction.userInterface.key;
    this.elementContainer = $(divContainer);

    if (callbacks && callbacks.beforeCreate) {
        callbacks.beforeCreate();
    }

    this.tabSelector =  tabSelector || this.entity;

    this.parseLayout(formLayout);

    this.renderForm = function () {

        var that = this,
            sectionRenderer = null,
            crudStage = that.crudStage,
            tabSelector = that.tabSelector,
            dataMapper,
            layout;

        if (App.Forms[that.entity] && App.Forms[that.entity].layout) {
            layout = App.Forms[that.entity].layout[crudStage];
            dataMapper = new Monet.Builder.DataMapper();
            dataMapper.setEntity(this.entity);
            dataMapper.build(null, layout);

        }

        this.renderedHTML += "<div id='form_" + that.entity + "'>";

        $.each(this.layout, function (index, item) {

            // o that.formLayout.userInterfaceAction.userInterface.key é a Entity
            // será utilizado em várias chamadas para identificar se o elemento está
            // dentro da aba correta

            sectionRenderer = new Monet.FormBuilder.SectionRenderer(item, crudStage, tabSelector);
            that.section = sectionRenderer.render();
            that.renderedHTML += that.section.html;

        });

        // Adiciona o formulário renderizado na página
        this.renderedHTML += "</div>";
        this.elementContainer.html(this.renderedHTML);

        Monet.I18n.checkResources();

        // Dispara todas as validações individuais dos campos

        Monet.Form.Validation.dispatchAll(tabSelector);

        // Inicializa o Objeto da Grid
        new Monet.FormBuilder.ActivateDataGrid(this.section.dataGrid, that.entity);


        // Inicializa as funções dos campos especiais, como o campos de busca por exemplo

        Monet.Form.initializeSpecialFields.runAll(that.tabSelector);
        Monet.Form.Validation.dispatchAll();

        if (callbacks && callbacks.afterCreate) {
            callbacks.afterCreate();
        }
    };

    return this;
};

Monet.FormBuilder.Utils = {

    upgradeLookupsToMonet2 : function (tabName, selectorComplement) {

        var _selectorComplement = selectorComplement || '';
        var lookups = document.querySelectorAll('#' + tabName + _selectorComplement +' div.control-group.lookup');
        var lookupArray = [];

        for (var i = 0, l = lookups.length; i < l; i++) {

            var lookup = new Monet.UI.Fields.PowerLookup ();
            var nameField = lookups[i].getAttribute('name');
            var nameFieldFormatted = nameField[0].toUpperCase() + nameField.substring(1);
            var nameSpace = nameFieldFormatted + 'Lookup';

            lookup.setId (lookups[i].id);
            lookup.setNameSpace(nameSpace);
            lookup.setBaseSelector('#' + lookups[i].id);
            lookup.setMandatory (lookups[i].getAttribute('mandatory'));
            lookup.setDisplayKey (lookups[i].getAttribute('lookup_entity_column'));
            lookup.setLookUpEntity (lookups[i].getAttribute('lookup_entity'));
            lookup.render ();
            lookup.setInputName (lookups[i].getAttribute('name'));
            lookup.setTextLabel (
                Monet.I18n.getResourcesByKey(
                    lookups[i].getAttribute('label')
                )
            );

            lookups[i].innerHTML = '';
            lookups[i].appendChild(lookup.rootEl);

            App.Forms[nameSpace] = App.Forms[nameSpace] || {};
            App.Forms[nameSpace].lookupElement = lookup;

            lookupArray.push (lookup);

        }

        return lookupArray;
    },

    upgradeLookupsListToMonet2 : function (tabName, selectorComplement) {

        var _selectorComplement = selectorComplement || '';
        var lookups = document.querySelectorAll('#' + tabName + _selectorComplement +  ' div.control-group.lookupList');

        for (var i = 0, l = lookups.length; i < l; i++) {

            var lookup = new Monet.UI.Fields.PowerLookupList();
            var nameField = lookups[i].getAttribute('name');
            var id = lookups[i].id.replace('.', '_');
            var nameFieldFormatted = nameField[0].toUpperCase() + nameField.substring(1);
            var nameSpace =  nameFieldFormatted + 'LookupList';

            lookup.setId (id);
            lookup.setNameSpace(nameSpace);
            lookup.setBaseSelector('#' + id);
            lookup.setMandatory (lookups[i].getAttribute('mandatory'));
            lookup.setDisplayKey (lookups[i].getAttribute('lookup_entity_column'));
            lookup.setLookUpEntity (lookups[i].getAttribute('lookup_entity'));
            lookup.render ();
            lookup.setInputName (nameField);
            lookup.setTextLabel (
                Monet.I18n.getResourcesByKey(
                    lookups[i].getAttribute('label')
                )
            );

            App.Forms[nameSpace] = App.Forms[nameSpace] || {};
            App.Forms[nameSpace].lookupElement = lookup;

            lookups[i].innerHTML = '';
            lookups[i].appendChild(lookup.rootEl);

        }

    }
};

Monet.FormBuilder.dataMapper = {

    parseLayout: function (formLayout) {

        var formKey = formLayout.userInterfaceAction.userInterface.key;

        Monet.DataMapper.checkNameSpace(formKey, ["dataMapper"], function () {

                if (App.Forms[formKey].dataMapper === "") {
                    App.Forms[formKey].dataMapper = {};
                }

                $.each(formLayout.sections, function (index, section) {
                    $.each(section.sectionFields, function (index_2, sectionField) {

                        App.Forms[formKey].dataMapper[sectionField.field.name] = {};
                        App.Forms[formKey].dataMapper[sectionField.field.name].type = sectionField.field.type;

                        if (typeof(sectionField.field.lookupEntity) !== "undefined") {
                            App.Forms[formKey].dataMapper[sectionField.field.name].lookupEntity = sectionField.field.lookupEntity.key;
                        }
                    });
                });
            }
        );

        return this;
    }
};

Monet.FormBuilder.prototype = {
    parseLayout: function () {
        this.page = this.formLayout.userInterfaceAction.userInterface;
        this.layout = this.formLayout.sections;
    }
};

Monet.FormBuilder.CrudStages = {
    NEW: 'new',
    EDIT: 'edit'
};

Monet.FormBuilder.SectionRenderer = function (item, crudStage, entity) {

    this.item = item;
    this.crudStage = crudStage;
    this.entity = entity;
    this.renderedHTML = "";
    this.section = {
        html: "",
        dataGrid: []
    };

    this.buttonRenderer = new Monet.FormBuilder.ButtonRenderer(item.sectionButtons, this.entity);
    this.fieldRenderer = new Monet.FormBuilder.FieldRenderer(item, crudStage);
    this.dataGridRenderer = new Monet.FormBuilder.RenderDataGrid(item.sectionRelatedLists);

    this.renderTitle = function () {
        if (this.item.description) {
            this.renderedHTML += Monet.UI.LayoutGenerator({
                "tag": "div",
                "items": [
                    {
                        "items": [
                            {
                                "tag": "h1",
                                "items": [
                                    {
                                        "tag": "span",
                                        "html": this.item.description,
                                        "attributes": {
                                            "class": "i18nResource"
                                        }
                                    }
                                ]
                            }
                        ],
                        "attributes": {
                            "class": "form_section_header " + this.item.description
                        }
                    }
                ]
            }).render().innerHTML;
        }
    };

    this.renderButtons = function () {

        this.renderedHTML += "<div style='position:relative; float:left; width: 100%'>";

        this.renderedHTML += this.buttonRenderer.render();

        this.renderedHTML += "</div>";

        if (item.sectionButtons.length > 0) {
            this.renderedHTML += new Monet.UI.LayoutGenerator({
                "tag": "div",
                "items": [{
                    "items": [
                        {
                            "attributes": {
                                "class": "monetInlineAlerContainer"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "hidden",
                                "id": "identity_id",
                                "value": "",
                                "class": "modelAttribute"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "hidden",
                                "id": "entity_name",
                                "value": this.entity,
                                "class": "modelAttribute"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "span8"
                    }
                }
            ]}).render().innerHTML;
        }

    };

    this.renderFields = function () {
        if (item.sectionFields !== undefined) {
            this.renderedHTML += this.fieldRenderer.render();
        }
    };

    this.renderDataGrid = function () {
        if (item.sectionRelatedLists) {
            var dataGrid = this.dataGridRenderer.render();
            this.renderedHTML += dataGrid.html;
            this.section.dataGrid = dataGrid.grids;
        }
    };

    this.render = function () {

        this.renderedHTML += "<div class='row'>";
        this.renderTitle();
        this.renderButtons();
        this.renderFields();
        this.renderDataGrid();
        this.renderedHTML += "</div>";

        this.section.html = this.renderedHTML;
        return this.section;

    };
};


/* Deixar sempre o render do Grid por ultimo, não é uma coisa programática,
 * é só pra facilitar minha vida */

Monet.FormBuilder.RenderDataGrid = function (grids) {

    this.dataGrids = {html: "", grids: []};
    this.dataGrid = {random_id: "", columns: []};
    this.renderedHTML = "";
    this.grids = grids;

    this.render = function () {

        var that = this,
            name = "",
            lastIndexIsFrozen = -1;

        $.each(this.grids, function (index, grid) {

            $.each(grid.searchGridLayout.searchGridColumns, function (index, column) {

                var addMenuToColumn = function () {

                    var menu = null,
                        monetGridUtils = Monet.Grid.Utils;

                    if (monetGridUtils.fieldCanHaveTotal(column.field.type)) {
                        menu = {
                            menu: {
                                items: [
                                    {
                                        iconImage: require('static/images/jstreew/throbber.gif'),
                                        title: Monet.I18n.getResourcesByKey("Greenmile.grid.showTotals.loadingData")
                                    }
                                ]
                            }
                        };
                    }

                    return menu;

                };

                if (column.field.lookupEntityColumn) {

                    name = column.field.name + "." + column.field.lookupEntityColumn;

                } else {

                    name = column.field.name;

                }

                if (column.isFrozen) {
                    lastIndexIsFrozen = index;
                }

                if (!Monet.Grid.blackList(name)) {
                    var sortable = true;

                    if (grid.searchGridLayout.entity.key === "AutoArriveLog" && column.field.name === 'message') {
                        sortable = false;
                    }

                    that.dataGrid.columns.push({
                        id: column.field.id,
                        name: Monet.I18n.getResourcesByKey(column.field.label),
                        field: name,
                        width: column.sizePixels,
                        cssClass: "cell-row",
                        sortable: sortable,
                        resizable: true,
                        fieldId: column.field.id,
                        fieldInformation: column.field,
                        header: addMenuToColumn(),
                        entity: grid.searchGridLayout.entity.key,
                        formatter: Monet.FormBuilder.FormatterGridColumn
                    });
                }

            });

            that.dataGrid.indexColumnFrozen = lastIndexIsFrozen;

            that.dataGrids.html += "<div id='table_view_container'>";
            that.dataGrids.html += Greenmile.Templates.templateGridListTemplate({
                title: ""
            });

            that.dataGrids.html += "</div>";

            that.dataGrids.grids.push(that.dataGrid);

        });

        return this.dataGrids;

    };

};

Monet.FormBuilder.PROGrid = function(value, dataContext, entity, field, fieldInformation, FormatterConstructor) {
    if (field === 'optimizationObjective') {
        return Monet.I18n.getResourcesByKey(value)
    }

    return value;
};

Monet.FormBuilder.ResequenceHistoryGrid = function (value, dataContext, entity, field, fieldInformation, FormatterConstructor) {

  let columnFormattedValue = "";
  const day = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.dayAbreviation");
  const hour = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.hourAbreviation");
  const min = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.minuteAbreviation");
  const sec = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.secondsAbreviation");

  if(field === 'resequenceTrigger'){
    value = Monet.I18n.getResourcesByKey(`resequenceTrigger.${value}`);
    const formatter = new FormatterConstructor(value, dataContext, entity, field, fieldInformation);
    columnFormattedValue = formatter.toGrid().getValue();
    return columnFormattedValue;
  }

  //these fields need to return an element containing the arrow + information
  else if(field === 'adjustedAddedTime' ||
          field === 'adjustedAddedDistance' ||
          field === 'adjustedMissingTimeWindows' ||
          field === 'adjustedMissedTimeWindowTime'){

    //these variables will be used in adjustedAddedTime field
    const momentObj = moment.duration(Math.abs(value));
    const valueDays = momentObj.days();
    const valueHours = momentObj.hours();
    const valueMinutes = momentObj.minutes();
    const valueSeconds = momentObj.seconds();

    const days = valueDays > 0 ? `${valueDays}${day}` : '';
    const hours = valueHours > 0 ? `${valueHours}${hour}` : '';
    const minutes = (valueHours > 0 || valueMinutes > 0) ? `${valueMinutes}${min}` : '';
    const seconds = valueSeconds > 0 ? `${valueSeconds}${sec}` : '';
    const timeString = `${days} ${hours} ${minutes} ${seconds}`;

    const isZero = ((value == 0) || (field === 'adjustedAddedTime' && !valueSeconds && !valueMinutes && !valueHours && !valueDays));

    let stringRes = (days.length > 0 || hours.length > 0 || minutes.length > 0 || seconds.length > 0) ?
                       timeString :
                      `0${min}`;

    stringRes = (value < 0 && !isZero) ? stringRes.trimStart().replace(/^/,'-') : stringRes.trimStart();

    //this formatter will be used in all fields except the adjustedAddedTime
    const formatter = new FormatterConstructor(value, dataContext, entity, field, fieldInformation);

    //we pass the true value to the toGrid method so it can return formatted values equals to 0.
    columnFormattedValue = formatter.toGrid().getValue();

    const result = (field === 'adjustedAddedTime' || field === 'adjustedMissedTimeWindowTime') ?
                    stringRes : `${columnFormattedValue}`;

    const icon = value < 0 ? 'green' : 'red';
    const finalValue = isZero ?
                       `<div class="adjustedResequenceAttr">
                          <div class="text left-padding"> ${result} </div>
                        </div>` :
                       `<div class="adjustedResequenceAttr">
                          <div class=${icon}></div>
                          <div class="text"> ${result} </div>
                        </div>`;

    return finalValue;

  }

  else if(field === 'resequencedTotalTime' ||
          field === 'priorTotalTime' ||
          field === 'resequencedMissedTimeWindowTime' ||
          field === 'priorMissedTimeWindowTime') {

    const valueDays = moment.duration(value).days();
    const valueHours = moment.duration(value).hours();
    const valueMinutes = moment.duration(value).minutes();
    const valueSeconds = moment.duration(value).seconds();

    const hoursPlusDays = valueHours + 24 * valueDays;

    const hours = valueHours > 0 ? `${hoursPlusDays}${hour}` : '';
    const minutes = `${valueMinutes}${min}`;
    const seconds = valueSeconds > 0 ? `${valueSeconds}${sec}` : '';

    return `${hours} ${minutes} ${seconds}`;
  }

  else if(field === 'finishedTime') {
    return moment(value).format("hh:mm A");
  }

  else {
    const formatter = new FormatterConstructor(value, dataContext, entity, field, fieldInformation);
    columnFormattedValue = formatter.toGrid().getValue();
    return columnFormattedValue;
  }
};

Monet.FormBuilder.FormatterGridColumn = function (row, cell, value, column, dataContext) {

    try {

        const entity = column.entity;
        const field = column.field;
        const fieldInformation = column.fieldInformation;
        const FormatterConstructor = Monet.Format[fieldInformation.type] || Monet.Format.Base;
        const getColumnFormattedValue = entity =>
            new FormatterConstructor(typeof value !== 'undefined' ? value : '', dataContext, entity, field, fieldInformation)
                .toGrid().getValue();

        const entityIncludes = createIncludesTestTo(entity);

        if (entityIncludes(['ResequenceHistory'])) {
          return Monet.FormBuilder.ResequenceHistoryGrid(value, dataContext, entity, field, fieldInformation, FormatterConstructor);
        } else if (entityIncludes(['ProactiveRouteOptConfig'])) {
          return Monet.FormBuilder.PROGrid(value, dataContext, entity, field, fieldInformation, FormatterConstructor);
        } else if (entityIncludes(['SkuBaseUnitLookup', 'SkuSecondaryUnitLookup', 'SkuTertiaryUnitLookup'])) {
          return getColumnFormattedValue('SizeAlias');
        } else if (entity === 'Organization') {
          return value;
        } else {
          return getColumnFormattedValue(entity);
        }

    } catch (e) {
        new Monet.Exception.ReturnError(this, "Error on formatter grid column", e)
            .console();
    }

};

Monet.FormBuilder.CreateIconHasPicture = function ( columnFormattedValue, dataContext, entity ) {
    const tabName = Monet.Utils.GetTabName();
    const dataContextModel = dataContext.model;
    const modelAttributes = dataContextModel && dataContextModel.attributes || {};
    const hasPhotosOnGallery = !!columnFormattedValue;
    const stopType = modelAttributes.stop && modelAttributes.stop.stopType && modelAttributes.stop.stopType.type;
    let error = null;
	try {
        const createIconElement = (attrs = {}) => {

            const initialAttrs = {
                'entity': modelAttributes.route && !modelAttributes.stop && 'route' || modelAttributes.stop && 'stop',
                'id': dataContext.idOfObject,
                'routeId': dataContextModel.get('route').id,
                'tabname': tabName,
                'onclick': 'Monet.FormBuilder.AddListenerHasPicture(this, event)'
            };

            const canNotShowGallery = stopType === 'DEPOT' || (!hasPhotosOnGallery && !/^(RouteDetails_\d+|RouteSummary)/.test(entity));
            if (canNotShowGallery) {
                delete initialAttrs.onclick;
            }

            if (entity === 'RouteSummaryStops' || /^RouteDetails_\d+/.test(entity)) {
                initialAttrs.id = dataContextModel.get('stop').id;
                initialAttrs.key = dataContextModel.get('stop').key;
            }

            if (entity === 'RouteSummaryRoutes') {
                initialAttrs.id = dataContextModel.get('route').id;
            }

            const element = document.createElement('div');
            const elementAttrs = { ...attrs, ...initialAttrs };

            for(let attr in elementAttrs) {
                element.setAttribute(attr, elementAttrs[attr]);
            }

            return element;
        }

	    return Monet.Grid.Utils.formatBooleanValue(hasPhotosOnGallery, {
            imgTrue : createIconElement({ class: 'iconWithPicture' }).outerHTML,
            imgFalse : createIconElement({ class: 'iconNoPicture' }).outerHTML
		});
	} catch(e) {
		error = new Monet.Exception.ReturnError(this, "Error on formatter icon picture", e);
	}
};

Monet.FormBuilder.AddListenerHasPicture = function(_, event) {
    const entity = event.target.getAttribute('entity');
    const routeId = Number(event.target.getAttribute('routeid'));
    const stopId = Number(event.target.getAttribute('id'));
    const key = event.target.getAttribute('key');

    window.GreenmileReduxStore.dispatch(
      actionsModals.openModal({
        modalKey: PHOTO_ALBUM_MODAL_KEY,
        data: {
          entity,
          routeId,
          stopId,
          key
        }
      })
    );
};

Monet.FormBuilder.CreateIconHasSurveyApplied = (hasSurveyApplied, dataContext) => {
    const routeId = dataContext?.model?.attributes?.route?.id;

    const iconElement = document.createElement("div");
    iconElement.className = hasSurveyApplied ? 'hasSurveyIcon' : 'noSurveyIcon';
    if (hasSurveyApplied && routeId) {
        iconElement.setAttribute('onclick', `Monet.FormBuilder.openRouteSurveyModal(${routeId}, event)`);
    }

    return iconElement.outerHTML;
}

Monet.FormBuilder.openRouteSurveyModal = (routeId, event) => {
    event.stopPropagation();

    let container = document.getElementById('routeSurveyModalContainer');
    if (!container) {
        container = document.createElement('div');
        container.id = 'routeSurveyModalContainer';
        document.getElementById('RouteSummary').appendChild(container);
    }

    renderComponent(
        <CustomProvider>
            <RouteSurveyModal
                parentSelector={() => container}
                routeId={Number(routeId)}
                stopId="without-stop"
                title={Monet.I18n.getResourcesByKey('routeSurveyModal.title')}
                subtitle={Monet.I18n.getResourcesByKey('routeSurveyModal.subtitle')}
            />
        </CustomProvider>,
        container
    );
    window.GreenmileReduxStore.dispatch(routeSurveyModalActions.actionCreators.open({ routeId: String(routeId), stopId: 'without-stop' }));
};

Monet.FormBuilder.CreateIconUnsuccessfulDelivery = (columnFormattedValue, dataContext) => {
    const dataContextModel = dataContext.model;
    const modelAttributes = dataContextModel && dataContextModel.attributes || {};
    const route = modelAttributes.route;

    const iconElement = document.createElement("div");
    iconElement.className = columnFormattedValue ? 'iconUnsuccessfulDelivery' : 'iconNoUnsuccessfulDelivery';
    iconElement.setAttribute("route-id", route.id);
    columnFormattedValue && iconElement.setAttribute("onclick", "Monet.FormBuilder.AddListenerUnsuccessfulDelivery(this, event)");

    return iconElement.outerHTML;
}

 Monet.FormBuilder.AddListenerUnsuccessfulDelivery = (context) => {
    const routeId = context.getAttribute("route-id");
    App.Forms.RouteSummaryStops.routeId = routeId;
    App.Forms.RouteSummaryStops.unsuccessfulDelivery = true;

    Monet.Grid.Utils.clearPagination('RouteSummaryStops');
    const hash = '#/RouteSummary/Stops';
    window.location = hash;
};

Monet.FormBuilder.CreateIconConformity = function ( bool ) {

  const divImgTrue = document.createElement('div');
  const divImgFalse = document.createElement('div');

  divImgTrue.className = 'iconConformity';
  divImgFalse.className = 'iconUnconformity';

  return Monet.Grid.Utils.formatBooleanValue(bool, {
      imgTrue : divImgTrue.outerHTML,
      imgFalse : divImgFalse.outerHTML
  });
};

Monet.FormBuilder.CreateIconHasSignature = function ( columnFormattedValue, dataContext, entity ) {

    var divImgTrue = document.createElement('div'),
        divImgFalse = document.createElement('div'),
        addListenerSignature = null,
        tabName = Monet.Utils.GetTabName(),
        error = null;


    try {

        !tabName.includes('RouteDetails') ? divImgTrue.className  = 'iconWithSignature' : divImgTrue.className = 'iconWithSignature signatureOnRouteDetails'
        divImgFalse.className = 'iconUnSigned';

        if( columnFormattedValue ) {

            addListenerSignature = "Monet.FormBuilder.AddListenerHasSignature(this)";

            divImgTrue.setAttribute('onclick', addListenerSignature);
            if( entity === 'RouteSummaryStops' ) {
                divImgTrue.setAttribute('id', dataContext.model.get('route').id);
            } else if( entity === 'RouteSummaryRoutes' ) {
                divImgTrue.setAttribute('id', dataContext.idOfObject);
            } else {
                divImgTrue.setAttribute('id', dataContext.model.get('route').id);
            }
            divImgTrue.setAttribute('akey', dataContext.model.attributes.stop.key);
            divImgTrue.setAttribute('tabname', tabName);

        }

        columnFormattedValue = Monet.Grid.Utils.formatBooleanValue(columnFormattedValue, {
            imgTrue : divImgTrue.outerHTML,
            imgFalse : divImgFalse.outerHTML
        });

        return columnFormattedValue;

    } catch(e) {

        error = new Monet.Exception.ReturnError(this,
            "Error on formatter icon signature",e);

    }

};

Monet.FormBuilder.AddListenerHasSignature = function( context ) {

    var akey = context.getAttribute("akey");
    var signature = new Greenmile.Gallery.Signature( context.id, akey );

    var obj = {
        "selector": "#" + context.getAttribute("tabname"),
        "scopeBlock": "#allContent",
        "width": 900,
        "height": 520
    };

    signature.show(obj);

};

Monet.FormBuilder.ActivateDataGrid = function (dataGrid, entity) {

    var error = null,
    paginateOptions = Monet.Grid.Utils.paginationOptions,
    showColumn = false,
    options = {},
    indexFrozenColumn = -1,
    dataView = null,
    grid = null,
    containner = null,
    columns = [],
    actions = ["CUSTOM_FILTERS", "SAVE_LAYOUT", "CUSTOMIZE_COLUMNS", "EXPORT_FORMATS" ];

    this.dataGrid = dataGrid;

    try {

        if (App.Forms[entity]) {

            App.Forms[entity].pagination = {
                first: paginateOptions.FIRST,
                max: paginateOptions.MAX_RESULT,
                blocked: false,
                canIncrement: true
            };

            if (this.dataGrid.length) {

                if (entity === "AutoArriveLog") {

                    showColumn = false;

                } else if (entity === 'TimeWindowTypeDays' || entity === 'LocationOverrideTimeWindow') {

                    actions = ["SAVE_LAYOUT", "CUSTOMIZE_COLUMNS", "EXPORT_FORMATS", "CUSTOM_FILTERS"];

                }

                indexFrozenColumn = this.dataGrid[0].indexColumnFrozen;

                options = {
                    entity: entity,
                    columnCheckBox: {
                        show: showColumn,
                        checkBoxEventClass: [Monet.Grid.ActionsModules.BatchDelete],
                        options: {
                            checkOnClickRow: true
                        }
                    },
                    columnEdit: {
                        show: showColumn
                    },
                    headerMenu: {
                        headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
                    },
                    actions: actions,
                    multiColumnSort: true,
                    frozenColumn: indexFrozenColumn
                };

                containner = '#' + entity + ' #grid';
                columns = this.dataGrid[0].columns;

                dataView = new Monet.Grid.DataProvider(columns, null, entity);

                var sections = App.Forms[entity].layout.index.sections;

                options = Monet.FormBuilder.checkPermissionToEditAndDeleteBySearchGridAction(sections, options);

                grid = new Monet.Grid.GenericGrid(containner, dataView, columns, options );

                App.Forms[entity].table = grid;
                App.Forms[entity].dataProvider = dataView;

            }

        }

    } catch (e) {

        error = new Monet.Exception.ReturnError(this,
            "Error on activate data grid", e);
        error.console();

    }

    return this;

};

Monet.FormBuilder.hasGridAction = function (sectionRelatedList, name) {

    var result = false;
    var hasGridAction = function (listGridActions) {
        return Boolean(
            listGridActions.filter(function (gridAction) {
                return gridAction.name === name;
            }).length
        );
    };

    if (sectionRelatedList.searchGridLayout.hasOwnProperty('searchGridActions')) {
        result = hasGridAction(sectionRelatedList.searchGridLayout.searchGridActions, name);
    }

    return result;

};

Monet.FormBuilder.checkPermissionToEditAndDeleteBySearchGridAction = function(sectionRelatedList, options) {

    var arrayPermission = ['btn_edit', 'btn_delete'];

    arrayPermission.forEach(function (item) {
        var result = Monet.FormBuilder.hasGridAction(sectionRelatedList, item);
        if (item === 'btn_edit') {
            options.columnEdit.show = result;
        } else if (item === 'btn_delete') {
            options.columnCheckBox.show = result;
        }
    });

    return options;

};

Monet.FormBuilder.appendUnitySystemMetricToLabel = function (inputSelector) {

    var selector = inputSelector,
        user = Monet.Session.User,
        unitySystemStr = "",
        resource = "",
        i18n = Monet.I18n,
        label = null,
        error = null;

    try {

        label = document.querySelector(selector);

        if (label !== null) {

            if (user.unitSystem === "METRIC") {

                if( selector.indexOf('perDistanceRateKm') >= 0) {
                    resource = "Greenmile.UnitMetrics.kilometersAbreviationParentheses";
                } else {
                    resource = "Greenmile.UnitMetrics.mettersAbreviationParentheses";
                }

            } else if (user.unitSystem === "NON_METRIC") {

                resource = "Greenmile.UnitMetrics.milesAbreviationParentheses";

            }

            unitySystemStr = i18n.getResourcesByKey(resource);

            label.innerHTML += " " + unitySystemStr;

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No input on DOM");
            error.console();
        }

    } catch (e) {
        error = new Monet.Exception.ReturnError(this,
            "Error on append unity system on label", e);
        error.console();
    }

};

Monet.FormBuilder.appendUnitySystemMetersOrMiles = function (inputSelector) {

    var selector = inputSelector,
        unitySystemStr = "",
        i18n = Monet.I18n,
        form = null,
        error = null;

    try {

        form = document.querySelector(selector);

        if (form !== null) {

            if (Monet.Session.User.unitSystem === "METRIC") {
                unitySystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.mettersAbreviationParentheses");
            } else {
                unitySystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.milesAbreviationParentheses");
            }

            form.innerHTML += " " + unitySystemStr;

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No input on DOM");
            error.console();
        }

    } catch (e) {
        error = new Monet.Exception.ReturnError(this,
            "Error on append unity system on label", e);
        error.console();
    }

};

Monet.FormBuilder.appendUnitySystemMetersOrFeet = function (inputSelector) {

    var selector = inputSelector,
        unitySystemStr = "",
        i18n = Monet.I18n,
        form = null,
        error = null;

    try {

        form = document.querySelector(selector);

        if (form !== null) {

            if (Monet.Session.User.unitSystem === "METRIC") {
                if( selector.indexOf('perDistanceRateKm') >= 0) {
                    unitySystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.kilometersAbreviationParentheses");
                }else{
                    unitySystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.mettersAbreviationParentheses");
                }

            } else {
                unitySystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.feetAbreviationParentheses");
            }

            form.innerHTML += " " + unitySystemStr;

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No input on DOM");
            error.console();
        }

    } catch (e) {
        error = new Monet.Exception.ReturnError(this,
            "Error on append unity system on label", e);
        error.console();
    }

};

Monet.FormBuilder.appendUnitySystemMinutes = function (inputSelector) {

    var selector = inputSelector,
        unitySystemStr = "",
        i18n = Monet.I18n,
        form = null,
        error = null;

    try {

        form = document.querySelector(selector);

        if (form !== null) {

            var parentNode = form.parentNode.parentNode;
            var labelResource = parentNode.getElementsByTagName("label");

            unitySystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.MinutesParentheses");

            if( typeof labelResource[0] !== 'undefined' ) {
                labelResource[0].innerHTML += " " + unitySystemStr;
            } else {
                labelResource = parentNode.parentNode.getElementsByTagName('span');
                labelResource[0].innerHTML += " " + unitySystemStr;
            }



        } else {
            error = new Monet.Exception.ReturnError(this,
                "No input on DOM");
            error.console();
        }

    } catch (e) {
        error = new Monet.Exception.ReturnError(this,
            "Error on append unity system on label", e);
        error.console();
    }

};
